(() => {
    // ensure that images are enscribed inside circle
    const exhibitorLogo = document.getElementById("exhibitorLogo");
    if(exhibitorLogo) {
        let prevScreenSizeAtLeastLarge = Foundation.MediaQuery.atLeast("large");
        let currScreenSizeAtLeastLarge = prevScreenSizeAtLeastLarge;
        const adjustImageHeight = () => {
            // size of logo depending on screen size (in px)
            const smallScreenSize = 105;
            const largeScreenSize = 127;

            const diameter = currScreenSizeAtLeastLarge ? largeScreenSize : smallScreenSize;
            const aspectRatio = exhibitorLogo.naturalWidth / exhibitorLogo.naturalHeight;
  
            // d^2 = ratio(h) + h^2
            exhibitorLogo.width = Math.sqrt( (Math.pow(diameter,2) / (Math.pow(aspectRatio,2) + 1))) * aspectRatio;
        }
        window.addEventListener("resize", () => {
            currScreenSizeAtLeastLarge = Foundation.MediaQuery.atLeast("large");
            if(currScreenSizeAtLeastLarge !== prevScreenSizeAtLeastLarge) {
                prevScreenSizeAtLeastLarge = currScreenSizeAtLeastLarge;
                adjustImageHeight();
            }
        });
        adjustImageHeight();
    }
})();